import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { colors, Divider } from '@material-ui/core';
import { Section, SectionAlternate } from 'components/organisms';
import {
  Customization,
  Hero,
  Hub,
  NutritionalInfo,
  Partners,
  Pricings,
  WhatsupBotton,
} from './components';

import { integrations } from './data';

// #PENDIENTE Este componente se repite para cada producto. Podria hacerse un solo componente generico
//que reciba las rutas de las imagenes y los textos. Esto reduce el numero de componentes.

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    width: '100%',
  },
  pagePaddingTop: {
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(5),
    },
  },
  sectionNoPaddingTop: {
    paddingTop: 0,
  },
  shape: {
    background: theme.palette.alternate.main,
    borderBottomRightRadius: '50%',
    borderBottom: `1px solid ${colors.grey[200]}`,
  },
}));

const LimonTahiti = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.shape}>
        <Section className={classes.pagePaddingTop}>
          <Hero />
        </Section>
        <Section className={classes.sectionNoPaddingTop}>
          <Hub />
        </Section>
      </div>
      <Section>
        <NutritionalInfo></NutritionalInfo>
      </Section>
      <SectionAlternate>
        <Customization />
      </SectionAlternate>
      <Divider />
    </div>
  );
};

export default LimonTahiti;
